/* @flow */

import * as React from 'react';
import styled from 'styled-components';
import { withRouter } from 'next/router';

import zIndexScale from '../../../utils/zIndexScale';
import NavCrumb from './NavCrumb';

import navCrumbs from '../../../config/nav-crumb';

const FIXED_HEADER_HEIGHT = 100;
let crumbInfo;

const Wrap = styled.div`
  width: 100%;
  ${({ isFixed }) => (isFixed ? `position:fixed;z-index:${zIndexScale.topNav};` : null)}
  left: 0;
  top: 0;
`;

type Router = {
  pathname: string,
  query: Object,
};

type Props = {
  router: Router,
};

type State = {
  isFixed: boolean,
};

export default
@withRouter
class Header extends React.PureComponent<Props, State> {
  static defaultProps = {
    router: { pathname: '', query: {} },
  };

  state = {
    isFixed: false,
  };

  componentDidMount() {
    const { pathname } = this.props.router;
    crumbInfo = navCrumbs[pathname];
    if (crumbInfo) {
      window.addEventListener('scroll', this._scroll);
    }
  }

  componentWillUnmount() {
    if (crumbInfo) {
      window.removeEventListener('scroll', this._scroll);
    }
  }

  _scroll = () => {
    const { documentElement }: Document = document;
    this.setState({
      // $FlowFixMe
      isFixed: documentElement.scrollTop > FIXED_HEADER_HEIGHT,
    });
  };

  render() {
    const { pathname, query } = this.props.router;
    crumbInfo = navCrumbs[pathname];
    if (!crumbInfo) {
      return null;
    }
    const { deviceName } = query; // TODO
    if (deviceName) {
      crumbInfo = { ...crumbInfo, [deviceName]: '' };
    }
    return (
      <Wrap isFixed={this.state.isFixed}>
        <NavCrumb crumbInfo={crumbInfo} />
      </Wrap>
    );
  }
}
